/**
 * Determines if an element is a form button or not.
 * @param element The HTMLElement to test.
 * @returns true if the HTMLElement is a button element or an input element with a type of submit.
 */
export const isFormButton = (element: HTMLElement) => {
	if (element.tagName === "BUTTON") {
		return true;
	}
	else if (element.tagName === "INPUT") {
		const type = element.getAttribute("type");
		return type && ["button", "submit"].includes(type);
	}
	return false
}